import { ITableColumn } from '../../../../../../../../components/UIWidgets/TableWrapper/models';
import { ICurrencyFormatter } from '../../../../../../../../services/selectors/portfolio';

export function getTopPositionsByPnLColumns(portfolioCurrencyFormatter: ICurrencyFormatter): ITableColumn[] {
  return [
    {
      label: 'Instrument Name',
      dataKey: 'instrumentName',
      flexGrow: 2,
      display: true,
      width: 400,
      disableSort: true,
    },
    {
      label: 'Custodian',
      dataKey: 'custodianName',
      flexGrow: 2,
      display: true,
      width: 200,
      disableSort: true,
    },
    {
      label: 'Asset Subclass',
      dataKey: 'assetSubClass',
      flexGrow: 2,
      display: true,
      width: 200,
      disableSort: true,
    },
    {
      label: `Current Value (${portfolioCurrencyFormatter()})`,
      dataKey: 'pnlMarketBase',
      flexGrow: 2,
      display: true,
      width: 200,
      disableSort: true,
    },
    {
      label: `P&L (${portfolioCurrencyFormatter()})`,
      dataKey: 'pnlBase',
      flexGrow: 2,
      display: true,
      width: 200,
      disableSort: true,
    },
    {
      label: '% of Portfolio P&L',
      dataKey: 'portfolioPercentage',
      flexGrow: 2,
      display: true,
      width: 200,
      disableSort: true,
    },
  ];
}
